namespace Vit.Administration {
    @Serenity.Decorators.registerClass()
    export class TenantEditor extends Vit.GridEditorBase<TenantRow> {
        constructor(container: JQuery) {
            super(container);
        }

        protected getColumnsKey() {
            return "Administration.Tenant";
        }

        protected getDialogType() {
            return TenantEditDialog;
        }

        protected getLocalTextPrefix() {
            return TenantRow.localTextPrefix;
        }

        protected getColumns() {
            var cols = super.getColumns();


            return cols;
        }

        protected onClick(event: JQueryEventObject, row: number, cell: number) {
            super.onClick(event, row, cell);

            if (event.isDefaultPrevented()) {
                return;
            }

            var item = this.itemAt(row);
            var target = $(event.target);

            if (target.parent().hasClass("inline-action")) {
                target = target.parent();
            }

            if (target.hasClass("inline-action")) {
                event.preventDefault();

            }
        }
    }
}